

import React, { useEffect } from 'react';
import { notification, Spin } from "antd";

import CompanyDetailSection from '../../shared/CompanyDetailSection';
import CustomerReviews from '../../shared/CustomerReviews';
import EnquireFormSection from '../../shared/EnquireFormSection';
import FeaturedCompaniesSection from '../../shared/FeaturedCompaniesSection';

const SchoolDetails = (props) => {
  const { getFeaturedIndustries, getPeopleNeededForHelp, enquireQuery, getCustomerReviews, likeCompanyType, subscribe, followCompanyType, shareCompany, getSchool, match, history, user, schoolDetails } = props;
  const { params } = match || {};
  const schoolId = params && params.id ? Number(params.id) : null;
  const { featuredSchools, school, numberOfPeople, customerReviews, loading } = schoolDetails || {};
  const companyType = 'School';
  useEffect(() => {
    if (schoolId) {
      getSchool(schoolId, user && user.id ? user.id : navigator.userAgent);
      getCustomerReviews();
      getFeaturedIndustries(companyType);
      getPeopleNeededForHelp();
    } else {
      notification.error({
        message: 'GET SCHOOL DETAILS',
        description: 'SchoolID is not valid'
      })
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div>
      <Spin spinning={loading}>
        <section className="school-details-banner gen-banner-2">
          <div className="container">
            <div className="banner-text">
              <h1 className="heading"> </h1>
              <p></p>
            </div>
          </div>
        </section>

        <CompanyDetailSection 
          data={school}
          numberOfPeople={numberOfPeople}
          companyType={companyType}
          subscribe={subscribe} 
          user={user}
          history={history}
          shareCompany={shareCompany}
          getIndustryDetails={getSchool}
          getCompanyTypeListings={getSchool}
          followCompanyType={followCompanyType}
          likeCompanyType={likeCompanyType}
        />
        <CustomerReviews data={customerReviews} loading={loading}/>
        <FeaturedCompaniesSection 
          data={featuredSchools}
          companyType={companyType}
        />
        <EnquireFormSection 
          enquireQuery={enquireQuery}
        />
      </Spin>
    </div>
  );
};

export default SchoolDetails;
